import { DayjsService } from '@core/services/dayjs.service';

/** `true` = badge permanente; data = visível até o dia informado (inclusive). */
export type MenuItemIsNew = boolean | Date | string;

export function isMenuItemNewActive(
  isNew: MenuItemIsNew | undefined,
  dayjsService: DayjsService
): boolean {
  if (isNew === undefined || isNew === null || isNew === false) {
    return false;
  }

  if (isNew === true) {
    return true;
  }

  const until = parseMenuItemDate(isNew, dayjsService);
  if (!until) {
    return false;
  }

  return dayjsService.compareIsSameOrBefore(
    dayjsService.startOfToday(),
    until,
    'day'
  );
}

function parseMenuItemDate(
  value: Date | string,
  dayjsService: DayjsService
): Date | null {
  const date = dayjsService.convertToDate(value);

  return Number.isNaN(date.getTime()) ? null : date;
}
